import { useQuery } from '@tanstack/react-query';
import { getWikiObjectByWikiid } from '../api/wikis';
import { WikiNamespaces } from '~/monolith-api';

export function getWikiKey(wikiid: number | null) {
   return ['get-wiki', wikiid];
}

export function useWiki(namespace: WikiNamespaces, wikiid: number | null) {
   const queryFunction = async () => {
      if (!wikiid) {
         return;
      }
      return await getWikiObjectByWikiid(namespace, wikiid);
   };

   return useQuery({
      queryFn: queryFunction,
      queryKey: getWikiKey(wikiid),
   });
}
